module.exports = __webpack_public_path__ + "static/img/130002.bf2164ee.png";